__webpack_require__.p = "/fragments/product-detail/legacy/";